var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64696 0.0878906C9.55796 0.0878906 13.466 0.0878906 17.374 0.0878906C26.028 1.85489 23.099 15.2099 23.69 25.0429C23.14 25.2869 22.807 24.4639 22.486 24.1399C19.516 21.1709 15.904 17.8179 12.864 14.8189C13.124 15.8609 12.532 17.3669 12.864 18.5799C13.143 19.5899 15.254 21.1179 16.173 22.0369C19.587 25.4529 22.974 29.1799 26.395 32.1099C25.446 21.6339 28.828 5.70889 23.388 0.088891C25.043 0.088891 26.697 0.088891 28.349 0.088891C31.41 0.735891 33.264 2.59189 33.911 5.64889C33.911 13.2159 33.911 20.7869 33.911 28.3539C33.264 31.4119 31.409 33.2659 28.349 33.9139C24.441 33.9139 20.532 33.9139 16.623 33.9139C7.96796 32.1449 10.898 18.7939 10.311 8.95989C10.858 8.71489 11.189 9.53789 11.513 9.86289C14.481 12.8309 18.093 16.1859 21.134 19.1829C20.876 18.1409 21.466 16.6349 21.134 15.4219C20.855 14.4119 18.746 12.8849 17.827 11.9649C14.411 8.54789 11.026 4.82089 7.60396 1.89089C8.55296 12.3679 5.17096 28.2919 10.609 33.9119C8.95796 33.9119 7.30296 33.9119 5.64696 33.9119C2.58696 33.2649 0.732961 31.4099 0.0849609 28.3519C0.0849609 20.7849 0.0849609 13.2139 0.0849609 5.64689C0.732961 2.59089 2.58796 0.734891 5.64696 0.0878906Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfc);
export default __webpack_public_path__ + "static/media/nfc.507afc520480e23050fb90403929c393.svg";
export { ForwardRef as ReactComponent };